export default "__VITE_ASSET__B0Y6e0zz__"